import ProfileModel from "../../../Profile/Models/ProfileModel";

export default class HighestSuccessRateModel {
    public position: number = null;
    public points: number = null;
    public predictionsMade: number = null;
    public profileId: string = null;
    public profileModel: ProfileModel = null;
    public successRatePercent: number = null;
}